/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popStarDeposit.vue?vue&type=template&id=6e38c78e&scoped=true"
import script from "./popStarDeposit.vue?vue&type=script&lang=js"
export * from "./popStarDeposit.vue?vue&type=script&lang=js"
import style0 from "./popStarDeposit.vue?vue&type=style&index=0&id=6e38c78e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e38c78e",
  null
  
)

export default component.exports